import * as Yup from 'yup';
export const fullNameSchema = Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be less than 100 characters')
    .matches(/^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:[ '-][A-Za-zÀ-ÖØ-öø-ÿ]+)*$/, 'Name can only contain letters, spaces, hyphens and apostrophes')
    .test('no-consecutive-special', 'Name cannot contain consecutive spaces, hyphens or apostrophes', (value) => !value || !/[ '-]{2,}/.test(value))
    .trim();
